/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * ChangHeon Yoo (chyoo@rsupport.com)
 *
 * @description
 *
 * @created at Tue Oct 24 2023
 **/

import { PropsWithChildren } from "react";
import { Button, Icon, Row, Typography, useModal } from "@/frameworks/designStuff/components";
import { _T } from "@rfice/language";

import * as S from "./emotion";

interface ButtonOptionType {
	title: string;
	buttonText?: string;
	disabled?: boolean;
	hasCancel?: boolean;
	handleCancel?: (ev: React.MouseEvent<HTMLButtonElement>) => void;
	handleSave?: (ev: React.MouseEvent<HTMLButtonElement>) => void;
	onClose?: () => void;
}

export default function Layout({
	title,
	buttonText,
	disabled,
	children,
	handleSave,
	handleCancel,
	hasCancel,
	onClose
}: PropsWithChildren<ButtonOptionType>) {
	const modal = useModal();

	return (
		<S.Wrapper gap={44}>
			<S.ContentWrapper>
				<Row
					style={{ justifyContent: "space-between", width: "100%", marginBottom: "12px", padding: "10px 0" }}
				>
					<Typography typoSize="Head6" typoColor="neutral_90_100">
						{title}
					</Typography>
					<Icon
						name="Close24"
						onClick={() => {
							onClose?.();
							modal.hideAll();
						}}
						style={{ cursor: "pointer" }}
					/>
				</Row>
				<S.ScrollWrapper>{children}</S.ScrollWrapper>
			</S.ContentWrapper>
			{handleSave && (
				<S.ButtonArea horizonAlign="right" gap={8}>
					{hasCancel ? (
						<Button filled="secondary" onClick={handleCancel}>
							{_T("취소")}
						</Button>
					) : null}
					<Button onClick={handleSave} disabled={disabled} filled="primary" css={{ width: "92px" }}>
						{buttonText ? buttonText : _T("저장하기")}
					</Button>
				</S.ButtonArea>
			)}
		</S.Wrapper>
	);
}
